var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tile mh-400 d-flex flex-column', _vm.tileClass]},[_c('h3',{staticClass:"mb-2"},[_vm._v("Open OC")]),_vm._v(" "),_c('orders-table',{attrs:{"orders":_vm.orders}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }